export const convertToCamelCase = (input: string): string => {
  const raw = typeof input === 'string' ? input : '';

  // Normalize unicode (remove diacritics) and trim
  const normalized = raw
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

  if (!normalized) return '';

  // Replace common separators with spaces
  const withSpaces = normalized.replace(/[\s_./\\-]+/g, ' ');

  // Insert spaces between camel/Pascal case boundaries, e.g. "MixedBerry" -> "Mixed Berry"
  const decamelized = withSpaces
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, '$1 $2');

  const parts = decamelized.split(/[^a-zA-Z0-9]+/).filter(Boolean);

  if (parts.length === 0) return '';

  const [first, ...rest] = parts;
  const head = first.toLowerCase();
  const tail = rest.map((segment) => {
    const lower = segment.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  });

  return [head, ...tail].join('');
};
